import React, { createContext, useMemo } from 'react';
export var ModalContext = createContext(null);
export var ModalConsumer = ModalContext.Consumer;
export var ModalProvider = function (_a) {
    var openModal = _a.openModal, children = _a.children;
    var context = useMemo(function () { return ({ openModal: openModal }); }, [openModal]);
    return (React.createElement(ModalContext.Provider, { value: context }, children));
};
//# sourceMappingURL=ModalContext.js.map